'use client';

import Flex from '@/components/Flex';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';

import { CustomButton } from '@/components/CustomButton';
import { EButtonSizes } from '@/components/CustomButton/CustomButton.types';
import { Search } from '@/components/Search';
import { ROUTES } from '@/constants';
import mainLogo from '@/svgs/logos/rollinews.svg';

import { useHeader } from '../Header.context';
import styles from '../Header.module.scss';

export const HDesktop: React.FC<{ openModal: () => void }> = ({
  openModal,
}) => {
  const pathname = usePathname();
  const { replace } = useRouter();
  const { searchValue } = useHeader();

  const handleSearch = (params: URLSearchParams) => {
    replace(`/search?${params.toString()}`);
  };

  const handleReset = () => {
    replace(pathname);
  };

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      gap="16px"
      className={styles.header_desktop}
    >
      <Link href={ROUTES.HOME} className={styles.logo}>
        <Image alt="Rollin News" src={mainLogo} />
      </Link>
      <Search
        onSearch={handleSearch}
        onReset={handleReset}
        value={searchValue}
        className={styles.customInput}
      />
      <CustomButton
        title="Download App"
        onClick={openModal}
        size={EButtonSizes.SM}
      >
        Descargar App
      </CustomButton>
    </Flex>
  );
};
